/* eslint-disable indent */
// 默认值
import {userAction} from '../action'
import defaultState, {UseDefaultStateType} from '../state/user'

type UserActionType = keyof typeof userAction

export type UserStateType = {
	user: UseDefaultStateType
}

export default function userReducer(state = defaultState, action: {type: UserActionType; payload: any}) {
	switch (action.type) {
		case userAction.UPDATE_TEA_INFO:
			return {
				...state,
				tea: action.payload
			}
		case userAction.RESET_USER_STORE:
			return defaultState
		default:
			return state
	}
}
